import React from 'react';
import { FORMS_DEFAULT_GAP_PX, getFormPlaceholderRows } from '../../services/forms-slot';
/**
 * Sized stand-in for the form while its field chunks load, mirroring the rows Forms will lay out so
 * the block does not change height when the real form arrives. Deterministic, so the server markup
 * and the first client render agree.
 */
export const FormPlaceholder = ({ form }) => {
    const rows = getFormPlaceholderRows(form);
    return (React.createElement("div", { "data-hook": "forms-slot-placeholder", "aria-hidden": "true", style: {
            display: 'flex',
            flexDirection: 'column',
            gap: `var(--wix-forms-formRowSpacing, ${FORMS_DEFAULT_GAP_PX}px)`,
            minHeight: rows.length ? undefined : 160,
        } }, rows.map((height, index) => (React.createElement("div", { 
        // eslint-disable-next-line react/no-array-index-key
        key: index, style: {
            height,
            borderRadius: 2,
            background: 'color-mix(in srgb, var(--ricos-text-color, #000) 8%, transparent)',
        } })))));
};
//# sourceMappingURL=form-placeholder.js.map